import { Component, Input, OnInit } from "@angular/core";
import { CouponInfoQr } from "@app/models";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-coupon-preview-modal",
  templateUrl: "./coupon-preview-modal.component.html",
  styleUrls: ["./coupon-preview-modal.component.scss"]
})
export class CouponPreviewModalComponent implements OnInit {
  @Input() item: CouponInfoQr;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  dismiss() {
    this.activeModal.dismiss();
  }
}
